/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here... 

jQuery('body').on("change", ".shipping-type", function () {
  jQuery('.cart__checkout').attr('disabled', 'disabled');
  let id = jQuery(this).attr('id');
  let value = jQuery(this).val();
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    data: {
      attributes: {
        'shipping-type': value
      }
    },
    success: function (result) {
      if (value == 'international') {
        update_button(true);
        $('.custom-footer-check').addClass('hidden');
        update_signature('', value);
        $('.signature-input').prop('checked', false);
        $('.message-signature').addClass('hidden');
      }
      else {
        update_button(true);
        $('.custom-footer-check').removeClass('hidden');
        update_signature('', value);
        $('.signature-input').prop('checked', false);
      }

    },
    error: function (jqxhr, status, exception) {
      console.log(exception);
    }
  });
});

jQuery('body').on("change", ".signature-input", function () {
  let value_shipping = jQuery(".shipping-type").val();
  let value = '';
  if (jQuery(this).prop('checked')) {
    value = jQuery(this).val();
  }
  update_signature(value, value_shipping);
});

jQuery('body').on("click", ".ajaxcart__checkout", function () {
  window.location.href = "/cart";
});

jQuery('body').on("click", ".cart-item__remove", function (event) {
  event.preventDefault();
  let remove_item = $(this).data('id');
  $('.num-minus-item-' + remove_item).val(0);
  $('.num-minus-item-' + remove_item).trigger('click');
});


function update_button(value) {
  if (value == true) {
    jQuery('.cart__checkout').removeAttr('disabled');
  }
}

function update_signature(signature, value) {
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    data: {
      attributes: {
        'signature-confirmation': signature
      }
    },
    success: function (result) {
      //console.log(value);
      //console.log(signature);
      if (value == 'usa') {
        if (signature == 'Yes') {
          update_button(true);
          $('.message-signature').addClass('hidden');
          add_signature();
        }
        else {
          $('.message-signature').removeClass('hidden');
          remove_signature();
        }
      }
      else {
        $('.message-signature').addClass('hidden');
        remove_signature();
      }
    },
    error: function (jqxhr, status, exception) {
      console.log(exception);
    }
  });
}

function remove_signature() {
  /*data = {
    "id": 40231114604613,
    "quantity": 0
  }
  $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: data,
      success: function(cart) {
          console.log('exito');
          change_cart(cart,'');
      },
      error: function(jqxhr, status, exception) {
          console.log(exception);
    }
  });*/
  $('.qty-minus-item-40231114604613').trigger('click');
}

function add_signature() {
  /*data = {
    "id": 40231114604613,
    "quantity": 1
  }
  $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: data,
      success: function(cart) {
          console.log('exito');
          change_cart(cart,'signature');
      },
      error: function(jqxhr, status, exception) {
          adjustCart();
    }
  });*/
  $('.js-product-add-signature').trigger('click');
}

function change_cart() {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    let total_price = cart.total_price / 100;
    jQuery('.cart__footer-total .money').html('$' + total_price);
    jQuery('.ajaxcart__footer-total .money').html('$' + total_price);
    verify_cart();
  });
}
function verify_cart() {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    console.log(cart.item_count);
    if (cart.item_count == 1) {
      let items = cart.items;
      for (i = 0; i < cart.item_count; i++) {
        if (items[i].id == 40231114604613) {
          console.log('siganture');
          //$('.qty-minus-item-40231114604613').trigger('click');
          $('.num-minus-item-40231114604613').val(0);
          $('.num-minus-item-40231114604613').trigger('click');
        }
      }
    }

    if (cart.item_count == 0) {
      var nullHash = {};
      var a = 0;
      for ([key, value] of Object.entries(cart.attributes)) {
        nullHash[key] = null;
        a++;
      }
      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: { attributes: nullHash },
        dataType: 'json'
      });
      let template_cart = $('body').hasClass('template-cart');

      if (a >= 1 && template_cart == true) {
        window.location.href = '/cart';
      }
    }
  });
}

window.onload = (event) => {
  verify_cart();
};

